<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Sample" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="sample.identifier"
            placeholder="Sample Name"
            :state="!$v.sample.identifier.$invalid"
            invalid-feedback="Required"
            @change="handleSampleChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group label="Add On(s)" label-cols="2">
      <b-button
        v-b-toggle="`addOns-${sample.test_package_sample_id}${submissionId}`"
        :variant="sample.add_ons.length ? 'primary' : 'dark'"
        block
        >Options</b-button
      >
      <b-collapse
        :id="`addOns-${sample.test_package_sample_id}${submissionId}`"
        class="mt-2"
      >
        <custom-form-checkbox-group
          v-model="sample.add_ons"
          v-if="addOns.length"
          :lg="2"
          :md="2"
          :options="
            addOns.map((i) => ({ text: i.name, value: i.id, icon: 'cube' }))
          "
          @change="handleSampleChange"
        />
      </b-collapse>
    </b-form-group>
  </div>
</template>
<script>
import CustomFormCheckboxGroup from "@/components/shared/form/CustomFormCheckboxGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectGeneralSampleFormGroup",
  components: { CustomFormCheckboxGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    sampleId: {
      type: String,
      default: "",
    },
    addOns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    sampleList() {
      return this.currentSubmission.samples;
    },
    sample() {
      return this.sampleList.find(
        (sample) => sample.test_package_sample_id === this.sampleId
      );
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
  },
  validations: {
    sample: {
      identifier: { required },
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSampleChange() {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.sampleList,
        name: "samples",
      });
    },
  },
};
</script>
